import React from 'react';
import { CellTemplateProps, ColumnProps } from 'fulogics-ui-web';
import GridColumnInspectorHelper from 'fulogics-ui-web/dist/layout/dx/DataGrid/helpers/GridColumnInspectorHelper';
import AllowedStacksHeader from './AllowedStacksHeader';

const AllowedStacksHeaderTemplate = (props: CellTemplateProps) => (
    <>
        <GridColumnInspectorHelper cellProps={props}>
            {(inspectorId, disableInspectorForm) => (
                <AllowedStacksHeader
                    disableInspectorForm={disableInspectorForm}
                    inspectorId={inspectorId}
                    defaultProps={AllowedStacksHeaderTemplateDefaultProps}
                />
            )}
        </GridColumnInspectorHelper>
    </>
);

export const AllowedStacksHeaderTemplateDefaultProps = {};
export const AllowedStacksHeaderTemplatePredProps = (current: ColumnProps): ColumnProps => {
    return {
        ...current,
    };
};
export type AllowedStacksHeaderTemplateData = {};
export const AllowedStacksHeaderTemplateDataKeys = [];
export default AllowedStacksHeaderTemplate;
